import { configureStore } from '@reduxjs/toolkit'
import dataSourceResSlice from './reducers/dataSourceResSlice'
import dataSourcePayloadSlice from './reducers/dataSourcePayloadSlice'
import companyDetailsSlice from './reducers/companyDetailsSlice'
import {
  datasourceListenerMiddleware,
} from "./reducers/datasSourceRefreshListener.js";
import dataSourceRefreshReducerSlice from './reducers/dataSourceRefreshReducerSlice';

export const store = configureStore({
  reducer: {
    dataSourceRes : dataSourceResSlice,
    dataSourcePayload:dataSourcePayloadSlice,
    companyDetails:companyDetailsSlice,
    datasource: dataSourceRefreshReducerSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(
      datasourceListenerMiddleware.middleware
    ),
})